export default () => {
  const button = document.querySelector('.header__button') as HTMLButtonElement;
  const nav = document.querySelector('.header__menu') as HTMLElement;

  if (!button || !nav) return;

  button.addEventListener('click', () => {
    nav.classList.toggle('active');
    button.classList.toggle('active');
  });
}
